import React from 'react';
import { View } from 'react-native';
import { ThemedView, ThemedText, Theme } from '@app/theme';
import { useTheme } from '@shopify/restyle';

const CreditLimitTooltip: React.FC<any> = ({ onClose }) => {
  const {colors} = useTheme<Theme>()
  return (
  <ThemedView
    position="absolute"
    top={26}
    right={-140}
    backgroundColor={'bg-surface-primary'}
    padding={"md"}
    borderColor={"border-primary"}
    borderWidth={1}
    borderRadius={"sm"}
    zIndex={9999}
    width={250}
    shadowColor="black"
    shadowOffset={{ width: 0, height: 2 }}
    shadowOpacity={0.25}
    shadowRadius={4}
    elevation={10}
    style={{
      shadowColor: 'rgba(0, 0, 0, 0.17)',
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 1,
      shadowRadius: 17
    }}
  >
    <ThemedView flexDirection={"row"}>
      <ThemedText variant="b5r" color="text-primary" >
        •
      </ThemedText>
      <ThemedText variant="b5r" color="text-primary" ml={"xs"}>
        Max amount that can be withdrawn from credit line
      </ThemedText>
    </ThemedView>
    <ThemedView flexDirection={"row"}>
      <ThemedText variant="b5r" color="text-primary">
        •
      </ThemedText>
      <ThemedText variant="b5r" color="text-primary" ml={"xs"}>
        Freely make multiple withdrawals and repayments within this credit limit
      </ThemedText>
    </ThemedView>
    {/* Arrow pointing up to the info icon */}
    <View style={{
      position: 'absolute',
      top: -8,
      right: 140,
      width: 0,
      height: 0,
      backgroundColor: 'transparent',
      borderStyle: 'solid',
      borderTopWidth: 0,
      borderRightWidth: 8,
      borderBottomWidth: 8,
      borderLeftWidth: 8,
      borderTopColor: 'transparent',
      borderRightColor: 'transparent',
      borderBottomColor: colors['bg-surface-primary'],
      borderLeftColor: 'transparent',
    }}/>
  </ThemedView>
)};

export default CreditLimitTooltip; 